exports.OWNER = [
  { oowner: 'Geo', otitle: 'Geo' },
  { oowner: 'NZBridge', otitle: 'NZ Bridge' },
  { oowner: 'public', otitle: 'public' }
]
